<!-- routify:options title='Admin' -->
<!-- routify:options index=2 -->
<!-- routify:options showInNavigation=true -->
<!-- routify:options flat=true -->
<!-- routify:options guards=['isLoggedIn'] -->

<script>
    import { ready } from '@sveltech/routify'

    /**
	 * since SSR normally won't render till all components have been loaded
	 * and our <slot /> will never load, we will have to let SSR do its job
	 * right away by calling $ready()
	 **/
	$ready()
</script>

<slot />
